import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import PaymentGDC from './Payment.GDC';
import PaymentGDG from './Payment.GDG';
import PaymentEFG from './Payment.EFG';
import { PAYMENT_METHOD, TYPE_OF_PAYMENTS } from '../payment_enums';

export const DefaultParams = {
  type: TYPE_OF_PAYMENTS.contract,
  value: '',
  currentStep: 0,
  payment: [],
  disabledNext: true
};

// Shared payer payload used by both PSE and Breb; each caller only adds its
// own extras (Breb doesn't require bank info, PSE does) on top.
const buildPayerRequest = payerInfo => ({
  id: '1',
  email: payerInfo.email.trim(),
  contactPhone: payerInfo.phone.trim(),
  phoneCountryCode: payerInfo.phoneCountryCode.trim(),
  identificationType: payerInfo.typeOfIdentification.trim(),
  identificationNumber: payerInfo.identification.trim(),
  address: payerInfo.addressFirstContract || '-',
  city: 'Barranquilla',
  clientType: payerInfo.typeOfPerson
});

export const buildPSERequest = (couponId, payerInfo) => {
  return {
    product: {
      couponId,
      paymentMethod: PAYMENT_METHOD.PSE
    },
    payer: {
      ...buildPayerRequest(payerInfo),
      fullName: payerInfo.payerFullName.trim(),
      financialInstitutionCode: payerInfo.currentBank,
      financialInstitutionName: payerInfo.currentBankName
    }
  };
};

export const buildBREBRequest = (couponId, payerInfo) => {
  const firstName = (payerInfo.firstName || '').trim();
  const lastName = (payerInfo.lastName || '').trim();
  const fullName = `${firstName} ${lastName}`.trim();

  return {
    product: {
      couponId,
      paymentMethod: PAYMENT_METHOD.BREB
    },
    payer: {
      ...buildPayerRequest(payerInfo),
      fullName,
      ...(firstName && { firstName }),
      ...(lastName && { lastName })
    }
  };
};

export const buildFinancingRequest = (
  financingInfo,
  payerInfo,
  requestId,
  paymentMethod = PAYMENT_METHOD.PSE
) => {
  const firstName = (payerInfo.firstName || '').trim();
  const lastName = (payerInfo.lastName || '').trim();
  const fullName =
    (payerInfo.payerFullName || '').trim() || `${firstName} ${lastName}`.trim();

  return {
    product: {
      ...financingInfo,
      paymentMethod
    },
    payer: {
      id: '1',
      fullName,
      email: payerInfo.email.trim(),
      contactPhone: payerInfo.phone.trim(),
      phoneCountryCode: payerInfo.phoneCountryCode.trim(),
      identificationType: payerInfo.typeOfIdentification.trim(),
      identificationNumber: payerInfo.identification.trim(),
      address: '-',
      city: 'Barranquilla',
      clientType: payerInfo.typeOfPerson,
      ...(paymentMethod === PAYMENT_METHOD.BREB && {
        ...(firstName && { firstName }),
        ...(lastName && { lastName })
      }),
      ...(paymentMethod === PAYMENT_METHOD.PSE && {
        financialInstitutionCode: payerInfo.currentBank,
        financialInstitutionName: payerInfo.currentBankName
      })
    },
    requestId
  };
};

const Payment = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <PaymentGDC {...props} />;
    case Portal.Gasguajira:
      return <PaymentGDG {...props} />;
    case Portal.Efigas:
      return <PaymentEFG {...props} />;
    default:
      return <></>;
  }
};

export default Payment;
